import { useEffect } from 'react';
import { usePrevious, useSetState } from 'react-use';
import { isEqual } from 'lodash-es';

export const useAsyncSetState = (value, callback, defaultState = {}) => {
  const [state, setState] = useSetState(defaultState);
  const prevValue = usePrevious(value);
  useEffect(() => {
    if (!isEqual(value, prevValue)) {
      setState(callback?.(value));
    }
  }, [value]);
  return [state, setState] as const;
};
